import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { AppState } from '../reducers/root.reducer';

const user = (state: AppState) => state.user;

const getUserState = createSelector(user, (user) => user);
const getPasswordState = createSelector(getUserState, (user) => user.password);

const UserSelectors = {
    getUserState,
    getPasswordState,
    useGetUserState,
    useGetPasswordState,
};

function useGetUserState() {
    return useSelector(getPasswordState);
}

function useGetPasswordState() {
    return useSelector(getPasswordState);
}

export default UserSelectors;
